// extracted by mini-css-extract-plugin
module.exports = {"container":"resetPassword_container__IatTC","info":"resetPassword_info__Ag_l2","success":"resetPassword_success__-DfS3"};